import React, { useMemo } from "react";
import "./index.scss";
import translates from "../../Formula/translates";
import { TranslateProvider, useTranslation } from "../../../i18n";
const sinusAssets = {
  normalSinusesLeft: {
    asset: require("./assets/normalSinusL.png"),
    top: 27,
    left: 910,
    width: 334,
    height: 150,
    zIndex: 1
  },
  normalSinusesRight: {
    asset: require("./assets/normalSinusR.png"),
    top: 27,
    left: 250,
    width: 363,
    height: 150,
    zIndex: 1
  },
  lowSinusesLeft: {
    asset: require("./assets/normalSinusL.png"),
    top: 89,
    left: 899,
    width: 334,
    height: 150,
    zIndex: 1
  },
  lowSinusesRight: {
    asset: require("./assets/normalSinusR.png"),
    top: 89,
    left: 267,
    width: 363,
    height: 150,
    zIndex: 1
  },
  sinusLiftingLeft: {
    asset: require("./assets/sinusLiftingL.png"),
    top: 90,
    left: 902,
    width: 329,
    height: 150,
    zIndex: 2
  },
  sinusLiftingRight: {
    asset: require("./assets/sinusLiftingR.png"),
    top: 84,
    left: 281,
    width: 336,
    height: 163,
    zIndex: 2
  }
};

const Sinus2D = ({
  sinuses,
  targetWidth = 400
}) => {
  const {
    _t,
    language
  } = useTranslation();
  const width = 1506;
  const height = 743;
  let scale = useMemo(() => {
    // return 1; // for test
    if (targetWidth) {
      return (targetWidth / width).toFixed(5);
    }

    return 0.5;
  }, [targetWidth]);

  function upscale(val) {
    return Math.round(val * scale);
  }

  const sinusInfo = useMemo(() => {
    return sinuses.filter(el => ["sinusLiftingLeft", "sinusLiftingRight"].includes(el)).map(el => translates(language, el));
  }, [language, sinuses]);
  return /*#__PURE__*/React.createElement("div", {
    className: "formula2DSinuses"
  }, /*#__PURE__*/React.createElement("div", {
    className: "formula2DSinuses-info"
  }, /*#__PURE__*/React.createElement("p", {
    className: "formula2DSinuses-info-title"
  }, _t("Синус-лифтинги:")), /*#__PURE__*/React.createElement("div", {
    className: "formula2DSinuses-info-list"
  }, sinusInfo.map(el => /*#__PURE__*/React.createElement("div", {
    key: el.string,
    className: "formula2DSinuses-info-list-item"
  }, /*#__PURE__*/React.createElement("img", {
    src: el.icon,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, el.string))))), /*#__PURE__*/React.createElement("div", {
    className: "formula2DSinuses-wrapper",
    style: {
      width: upscale(width),
      height: upscale(height)
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: require("./assets/panoramic.png"),
    style: {
      position: "absolute",
      width: upscale(1506),
      height: upscale(743),
      top: upscale(0),
      left: upscale(0)
    },
    alt: ""
  }), sinuses.map(el => /*#__PURE__*/React.createElement("img", {
    key: el,
    src: sinusAssets[el].asset,
    style: {
      position: "absolute",
      width: upscale(sinusAssets[el].width),
      height: upscale(sinusAssets[el].height),
      top: upscale(sinusAssets[el].top),
      left: upscale(sinusAssets[el].left)
    },
    alt: ""
  }))));
};

const Sinus2DWrapper = props => {
  return /*#__PURE__*/React.createElement(TranslateProvider, null, /*#__PURE__*/React.createElement(Sinus2D, props));
};

export default Sinus2DWrapper;